<template>
  <div>
    <h1>Agent work time</h1>
    <v-layout wrap align-end class="pa-2">
      <v-flex xs12 sm6>
        <div style="max-width: 300px">
          <StatusOverview />
        </div>
      </v-flex>
      <v-flex xs12 sm6 style="display: flex; justify-content: flex-end; align-items: flex-end">
        <div class="pr-2">
          <div class="caption">Group</div>
          <multiselect
            v-model="filterAgentGroup"
            :options="agentGroupOptions"
            select-label
            selected-label
            :allow-empty="true"
            :searchable="true"
            label="groupname"
            placeholder="select group"
            :disabled="isAgent"
            style="width: 200px"
            @input="handleFetchData()"
          ></multiselect>
        </div>
        <div class="px-2">
          <div class="caption">Agent</div>
          <multiselect
            v-model="filterAgent"
            :options="agentOptions"
            select-label
            selected-label
            :allow-empty="true"
            :searchable="true"
            style="width: 200px"
            @input="handleFetchData()"
          ></multiselect>
        </div>
        <div class="pl-2">
          <v-btn outline color="primary" class="ma-0 mb-1" @click="handleExportExcel">
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
          </v-btn>
        </div>

        <!-- <v-btn color="primary" @click="handleExportExcel">
          <v-icon>logout</v-icon>
          {{ $t('export') }}
        </v-btn> -->
      </v-flex>
    </v-layout>

    <DataTable :items="dataList" />
    <div class="mt-2">
      <v-pagination
        v-model="pageNumber"
        :total-visible="6"
        :length="pageLength"
        @input="handleChangePage"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ticket3AgentManagementApi from '@/api/ticket3/agent-management'
import dayjs from 'dayjs'
import DataTable from './DataTable.vue'
import XLSX from 'xlsx'
import StatusOverview from './StatusOverview.vue'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    DataTable,
    StatusOverview,
    Multiselect
  },
  data() {
    return {
      loading: false,
      limit: 20,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pageTemp: 1,
      pageNumber: 1,
      dataList: [],
      timer: null,
      isExport: false,
      filterAgent: '',
      filterAgentGroup: { groupname: 'All', id: '' }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageLength() {
      if (this.total) {
        const total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    agentGroupList() {
      return this.$store.state.agentGroups
    },
    agentGroupOptions() {
      if (this.agentGroupList && this.agentGroupList.length > 0) {
        return [{ groupname: 'All', id: '' }, ...this.agentGroupList]
      }
      return [{ groupname: 'All', id: '' }]
    },
    agentList() {
      return this.$store.state.agents
    },
    agentOptions() {
      let options = []
      if (this.isAgent) {
        options = this.agentList
          .filter((agent) => agent.adminid === this.$store.state.userid)
          .map((el) => el.adminid)
      } else {
        options = this.agentList.map((el) => el.adminid)
      }
      return options
    },
    isAgent() {
      return this.$store.state.privilege && this.$store.state.privilege.role == 'agent'
    }
  },
  mounted() {
    const vm = this
    try {
      if (this.agentGroupList.length === 0) {
        this.$store.dispatch('loadAgentGroups')
      }

      if (vm.agentList.length === 0) {
        vm.$store.dispatch('loadAgents')
      }

      vm.handleFetchData()
      vm.timer = setInterval(async () => {
        vm.handleFetchData()
      }, 1000 * 60 * 5)
    } catch (error) {
      console.error(error)
    }
  },
  methods: {
    async handleFetchData() {
      const vm = this
      try {
        vm.loading = true
        const response = await vm.getAgentWorkTime()

        if (response && response.status === 200 && response.data) {
          vm.dataList = response.data.data
          vm.total = response.data.total
        }
        vm.loading = false
      } catch (error) {
        vm.loading = false
        console.error(error)
      }
    },
    async getAgentWorkTime() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          limit: vm.isExport ? vm.total : vm.limit,
          offset: vm.offset
        }

        if (this.filterAgent) {
          Object.assign(data, { name: this.filterAgent })
        }

        if (this.filterAgentGroup && this.filterAgentGroup.id) {
          Object.assign(data, { group_id: this.filterAgentGroup.id })
        }

        const response = await ticket3AgentManagementApi.getAgentWorkTime({ params: data })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pageTemp !== val) {
        vm.pageTemp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        vm.handleFetchData()
      }
    },
    async handleExportExcel() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        vm.isExport = true
        vm.offset = 0
        const response = await vm.getAgentWorkTime()
        vm.isExport = false

        if (response === null) {
          vm.$store.commit('CLEAR_LOADING')
          return
        }

        const responseData = response.data.data

        const data = responseData.map((el) => {
          return {
            adminid: el.adminid,
            check_in_time: el.check_in_time
              ? dayjs(el.check_in_time).format('DD/MM/YYYY HH:mm')
              : '-',
            check_out_time: el.check_out_time
              ? dayjs(el.check_out_time).format('DD/MM/YYYY HH:mm')
              : '-',
            duration:
              el.check_in_time && el.check_out_time
                ? vm.getDurationTime(el.check_in_time, el.check_out_time)
                : '-'
          }
        })

        const heading = [['Agent', 'Check-in time', 'Check-out time', 'Duration']]
        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, data, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `agent-work-time.xlsx`)
        vm.$store.commit('CLEAR_LOADING')
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    getDurationTime(from, to) {
      const diff = dayjs(to).diff(dayjs(from), 'second')
      const display = this.transformDurationTime(diff)
      return display
    },
    transformDurationTime(value) {
      const hours = Math.floor(value / 3600)
      const minutes = Math.floor((value % 3600) / 60)

      const hDisplay = hours > 0 ? `${hours}  ${this.$t('Hours')}` : ''
      const mDisplay = minutes > 0 ? ` ${minutes} ${this.$t('Minutes')}` : ''
      return `${hDisplay} ${mDisplay}`
    },
    handleSearchInput() {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/agents/WorkTime/index.vue